import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Button,
    Checkbox,
    CircularProgress,
    Alert,
    Tabs,
    Tab,
    TextField,
    IconButton,
    InputAdornment,
    Collapse,
    TableFooter
} from '@mui/material';
import {
    ArrowDownward,
    ArrowUpward,
    Search,
    KeyboardArrowDown,
    KeyboardArrowUp
} from '@mui/icons-material';

import HoldingsList from './HoldingsList';
import OverdueStocks from './OverdueStocks';
import PortfolioOverdueTable from './PortfolioOverdueTable';
function TabPanel({ value, index, children }) {
    return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
}

const SellStocks = ({ holdings, dueHoldings }) => {

    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Box>
            <Typography variant="h5" gutterBottom sx={{ color: '#2d4890', mb: 2, padding: '20px' }}>
                📈 Divest Portfolio Holdings
            </Typography>

            <Paper elevation={3} sx={{ mb: 2 }}>
                <Tabs value={tabIndex} onChange={(_, val) => setTabIndex(val)} centered>
                    <Tab label="Divest Holdings Analysis" />
                    <Tab label="Stocks Due for Sell" />
                    <Tab label="Sell All Holdings" />
                </Tabs>
            </Paper>
            <TabPanel value={tabIndex} index={0}>
                <PortfolioOverdueTable stocks={dueHoldings.overdue_positions_analysis} lastCreatedStocksDue={dueHoldings.metadata?.file_info.created_timestamp} overdueAlert={dueHoldings.discrepancy_alert_message} />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
                <OverdueStocks holdings={dueHoldings.overdue_positions_analysis} lastCreatedStocksDue={dueHoldings.metadata?.file_info.created_timestamp} overdueAlert={dueHoldings.discrepancy_alert_message} />
            </TabPanel>
            <TabPanel value={tabIndex} index={2}>
                <HoldingsList holdings={holdings} />
            </TabPanel>
        </Box>
    );
};

export default SellStocks;
